module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-120x120-25640ba07082fa9a59b96a5d36cc943e.png";